module.exports = __webpack_public_path__ + "res/Roboto-Light-webfont.ttf?a2591fee97a2e69017a989dbd7026517";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-Light-webfont.ttf
// module id = 69
// module chunks = 0